<template>
  <div id="update-data-page">
    <h2 class="intro-y text-lg font-medium mt-10">
      更改主題
    </h2>

    <thread-form v-if="mounted && (checkPermission(permissions, 'site.forum.edit') || (data != null && checkPermission(permissions, 'site.forum.create') && data.user_id == profile.user_id))" :data="data" :site="currentSite" :auth="auth" :current-site="currentSite" :permissions="permissions" :profile="profile"></thread-form>

    <div v-else-if="mounted">
      <div class="alert alert-danger show mt-2" role="alert">沒有權限查看</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['auth', 'currentSite', 'permissions', 'profile'],
  data() {
    return {
      mounted: false,
      data: null
    }
  },
  watch: {
    auth(val) {
      if (val) {
        this.init()
      }
    },
    currentSite() {
      this.init()
    },
    permissions() {
      this.init()
    }
  },
  async mounted() {
    if (!this.auth) {
      return
    }

    await this.init()
  },
  methods: {
    async init() {
      if (this.currentSite && this.permissions) {
        await this.loadData()

        setTimeout(() => {
          this.mounted = true
        }, 500)
      }
    },
    async loadData() {
      this.data = await this.getSiteForumThread(this.currentSite.site_id, this.$route.params.threadId)
    }
  }
}
</script>

<style lang="scss" scoped></style>
